'use strict';

module.exports = function(){

  console.log( "wtf" );


  // StartAudioContext.setContext(Tone.context);
  // StartAudioContext.on("#container");

  StartAudioContext(Tone.context, '#container', ()=>{
    console.log( "start audio" );
    // if(isSafari)  alert('StartAudioContext')
  });

  return {
    onRAF: function(){


      if(Tone.context.state && Tone.context.state === "suspended") {
        Tone.context.resume().then(function() {
          console.log("AudioContext resumed!");
          // fire your callback here
        });
      }

      // if(Tone.context.state && Tone.context.state === "suspended") {
      //   Tone.context.resume().then(function() {
      //     console.log("AudioContext resumed!");
      //     // fire your callback here
      //   });
      // }
    }
  }
}
